import React, { useCallback } from 'react';

import Button from '../Button/Button';
import inIframe from '../../utils/isInIframe/isInIframe';
import Link from '../Link/Link';

interface TourLinkProps {
    tourId: string;
}

/*
    TourLink can return two different components with different behaviours:
    1.  If application is embedded into iframe and there's openTourEvent=true in
        URL it will send an event to parent that it was clicked without any other actions.
        This gives possibility to customize the behaviour on "View" click.
    2. Default: open tour in new tab when it's clicked.
 */
const TourLink = ({ tourId }: TourLinkProps) => {
    const { REACT_APP_OPEN_TOUR_EVENT } = process.env;
    const queryParams = new URLSearchParams(window.location.search);
    const openTourEvent = queryParams.get(String(REACT_APP_OPEN_TOUR_EVENT));

    const sendOpenTourEvent = useCallback(() => {
        window.parent.postMessage(
            JSON.stringify({
                tourId,
            }),
            document.referrer
        );
    }, [tourId]);

    if (openTourEvent === 'true' && inIframe())
        return <Button onClick={sendOpenTourEvent}>View</Button>;

    return (
        <Link path={`https://tour.tourbuilder.com/?tour=${tourId}`}>View</Link>
    );
};

export default TourLink;
